module.exports = __webpack_public_path__ + "Qualcomm-02b58aca.webp";